/**
 * 短时结果缓存 + 并发去重：同一 key 在窗口内只打一次网络。
 * 用于欢迎页多组件重复拉取 farms / devices / operation-slots 等。
 */

const inflight = new Map();
const store = new Map();

/**
 * @template T
 * @param {string} key
 * @param {() => Promise<T>} factory
 * @param {number} [ttlMs=12000]
 * @returns {Promise<T>}
 */
export function shortLived(key, factory, ttlMs = 12000) {
  const k = String(key || '');
  if (!k) return Promise.resolve().then(factory);

  const now = Date.now();
  const hit = store.get(k);
  if (hit && now - hit.at < ttlMs) {
    return Promise.resolve(hit.value);
  }

  const pending = inflight.get(k);
  if (pending) return pending;

  const p = Promise.resolve()
    .then(factory)
    .then((value) => {
      store.set(k, { value, at: Date.now() });
      inflight.delete(k);
      return value;
    })
    .catch((err) => {
      inflight.delete(k);
      throw err;
    });

  inflight.set(k, p);
  return p;
}

/** 可选：主动失效（运营位保存后等） */
export function invalidateShortLived(prefix) {
  const p = String(prefix || '');
  if (!p) {
    inflight.clear();
    store.clear();
    return;
  }
  for (const key of [...inflight.keys()]) {
    if (key.startsWith(p)) inflight.delete(key);
  }
  for (const key of [...store.keys()]) {
    if (key.startsWith(p)) store.delete(key);
  }
}
